/* ==========================================================================
   GLANTEX - Variantenanzeige aktualisieren

   PROBLEM: snippets/variant-button.liquid gibt ueber der Kachelreihe den
   Namen der Option und den gewaehlten Wert aus:

       <p class="gtx-var__titel">Groesse <span>1 STUECK</span></p>

   Dieser Wert stammt aus option.selected_value und wird damit EINMAL beim
   Rendern der Seite gesetzt. Der Variantenwechsel laeuft danach rein im
   Browser ab (theme.js schreibt Preis, Verfuegbarkeit, Bild und die
   Variant-ID in der Adresszeile neu) - die Ueberschrift blieb dabei auf
   dem Wert stehen, mit dem die Seite geladen wurde. Wer also "2 STUECK"
   waehlte, las darueber weiterhin "1 STUECK".

   Das Motion-Theme hat fuer genau diesen Zweck einen Haken, nutzt ihn
   aber nur fuer Farboptionen: updateColorName() schreibt in
   [data-variant-color-label]. Der GLANTEX-Titel ersetzt jenes Label,
   trug aber keinen solchen Haken - deshalb hat ihn nie jemand
   aktualisiert.

   LOESUNG: Ein einziger delegierter Zuhoerer am Dokument. Er greift
   dadurch auch in Schnellansicht-Modalen und in nachtraeglich
   eingefuegten Produktbloecken, ohne dass irgendwo eine zweite
   Initialisierung noetig waere.

   Die Quelle des Werts ist bewusst das Radio-Feld selbst: dessen value
   wird aus demselben option.values gerendert wie die Ueberschrift. Damit
   koennen die beiden gar nicht auseinanderlaufen.
   ========================================================================== */

(function () {
  // Die Datei wird aus variant-button.liquid geladen, und dieses Snippet
  // laeuft einmal JE OPTION. Bei zwei Optionen stuende das script-Tag also
  // zweimal auf der Seite. Ohne diese Sperre haengen dann mehrere
  // Zuhoerer an denselben Feldern.
  if (window.__gtxVariantenAnzeige) {
    return;
  }
  window.__gtxVariantenAnzeige = true;

  document.addEventListener('change', function (evt) {
    var feld = evt.target;

    if (!feld || feld.type !== 'radio' || !feld.hasAttribute('data-variant-input')) {
      return;
    }
    if (!feld.checked) {
      return;
    }

    var gruppe = feld.closest('.gtx-var');
    if (!gruppe) {
      return;
    }

    // Vorrang hat die Anzeige mit derselben Optionsnummer. Bei Produkten
    // mit mehreren Optionen hat jede Option ihre eigene Gruppe samt
    // eigener Ueberschrift; der Index haelt die Zuordnung auch dann
    // richtig, wenn sich die Verschachtelung einmal aendert.
    var index = feld.getAttribute('data-index');
    var ziel =
      gruppe.querySelector('[data-gtx-var-wert="' + index + '"]') ||
      gruppe.querySelector('[data-gtx-var-wert]');

    if (ziel) {
      ziel.textContent = feld.value;
    }
  });
})();
